import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import usePaginatedResources from "hooks/usePaginatedResources";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import useGetProductGroups from "./useGetProductGroups";
import DeleteProductGroup from "modules/productGroups/DeleteProductGroup";
import { Box } from "@mui/material";

export default function useProductGroupsTable() {
  const { filtering, offset } = usePaginatedVariables();
  const { data, loading, error, paginatorInfo } = useGetProductGroups({
    page: offset.page,
    first: offset.first,
    search: filtering.debouncedSearchTerm,
  });

  const pagination = usePaginatedResources({
    paginatorInfo,
    paginate: offset.paginate,
  });

  const columns = useMemo(() => {
    return [
      {
        Header: "Group Name",
        accessor: "name",
        width: "50%",
        Cell: ({ value, row }) => (
          <Link style={{ color: "inherit" }} to={`/product-groups/${row.values.id}/update`}>
            {value}
          </Link>
        ),
      },
      {
        Header: "Product Count",
        accessor: "products",
        width: "30%",
        Cell: ({ value }) => value?.length || 0,
      },
      {
        Header: "Actions",
        accessor: "id",
        width: "20%",
        Cell: ({ value, row }) => (
          <Box display="flex" gap={1} alignItems="center">
            <Link to={`/product-groups/${value}/update`}>Edit</Link>
            <DeleteProductGroup id={value} name={row.values.name} />
          </Box>
        ),
      },
    ];
  }, []);

  const tableData = useMemo(() => {
    return { columns, rows: data };
  }, [columns, data]);

  return {
    data,
    loading,
    error,
    columns,
    tableData,
    pagination,
    filtering,
    paginatorInfo,
  } as const;
}
